import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const NonReceivedPartsPO = {
	name: NAME,
	apiProvider,
	router,
};
